export const dungeonMaker = {
  name: "Dungeon Maker",
  excerpt: "Dungeon Building Mobile App",
  image: "simpleLeadTracker.webp",
  localUrl: "dungeon-maker",
  featured: true,
  url: "#",
  description: "Dugeon Maker is a mobile app for buidling tiled dungeons. The perfect tool for any dungeon master and RPG lover.",
  challenge: "Building a map editor that is easy to use on mobile is not easy, but we were up for the challenge. A map editing tool is inherently complex, and this can make creating a mobile friendly UI difficult.",
  solution: "Our end solution creates a separation between drawing and moving. This gives the user control without introducing lots of complex touch interactions. We also provide multiple drop-down panels to help control core functionality. We've further updated the app with new features inclduing terrain tiles.",
  tech: ["Clojurescript", "Cordova", "MySqlLite"],
  images: ["simpleLeadTracker.webp", "simpleLeadTracker.webp", "simpleLeadTracker.webp"]
}
